<app-content-auth>
	<div class="right_login">
		<div class="content_form">
			<app-first-login-form></app-first-login-form>
		</div>
	</div>
</app-content-auth>
